import { copyArrayWithoutReference } from "utils";

import { ALLOCATED_NUMBERS_MODE } from "./Mode";

export const getTableDataByMode = ({
    mode,
    currentDisplay,
    numbersData,
    suppliersPrefixList,
    suppliersGroupList,
}) => {
    if (mode === ALLOCATED_NUMBERS_MODE.transit) {
        return copyArrayWithoutReference(suppliersPrefixList || []).filter((item) => {
            return item && Object.prototype.hasOwnProperty.call(item, "prefix");
        });
    }

    if (mode === ALLOCATED_NUMBERS_MODE.gan) {
        const ganData = {
            numbers: copyArrayWithoutReference(suppliersPrefixList || []),
            groups: copyArrayWithoutReference(suppliersGroupList || []),
        };

        return ganData[currentDisplay] || [];
    }

    return numbersData;
};

export const getTablePagingByMode = ({
    isSupplier,
    allocatedNumbersCount,
    allocatedNumbersPage,
    allocatedNumbersPerPage,
    suppliersPrefixListCount,
    suppliersPrefixListPage,
    suppliersPrefixListPerPage,
}) => ({
    dataCount: isSupplier ? suppliersPrefixListCount : allocatedNumbersCount,
    dataPage: isSupplier ? suppliersPrefixListPage : allocatedNumbersPage,
    dataPerPage: isSupplier ? suppliersPrefixListPerPage : allocatedNumbersPerPage,
});
